import { Alert, Button, Icons } from '@healthinal/ui';
import { HeurekaCondition } from '../api/heurekaPatientDetails';
import { useHeurekaUpdateGrantsRedirect } from '../utils/heurekaRedirect';
import { useHeurekaResourceAvailability } from '../utils/heurekaResourceAvailability';
import ConditionTable from './ConditionTable';

interface ConditionsSectionProps {
  conditions: HeurekaCondition[] | null;
}

export function ConditionsSection({ conditions }: ConditionsSectionProps) {
  const { readConditions } = useHeurekaResourceAvailability();
  const updateGrants = useHeurekaUpdateGrantsRedirect();

  if (readConditions === 'UNSUPPORTED') {
    return (
      <Alert variant="soft" sx={{ mb: 6 }} color="neutral" startDecorator={<Icons.InfoOutlined />}>
        Aktuell werden Diagnosen für Ihr PIS nicht unterstützt
      </Alert>
    );
  }

  if (readConditions === 'NOT_GRANTED') {
    return (
      <Alert
        variant="soft"
        sx={{ mb: 6 }}
        color="warning"
        startDecorator={<Icons.InfoOutlined />}
        endDecorator={
          <Button color="warning" variant="soft" size="sm" onClick={updateGrants}>
            Berechtigungen anpassen
          </Button>
        }>
        Diagnosen konnten nicht geladen werden
      </Alert>
    );
  }

  if (conditions && conditions.length > 0) {
    return <ConditionTable conditions={conditions} title="Diagnosen" />;
  }

  return (
    <Alert variant="soft" startDecorator={<Icons.InfoOutlined />}>
      Keine Diagnosen gefunden
    </Alert>
  );
}
